import styled from "styled-components";

interface MainPostTabStyleProps {
  $active?: boolean;
}

export const MainPostTab = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const TabBox = styled.div`
  display: flex;
  width: 100%;
  // padding: 4px;
  // border: 1px solid ${(props) => props.theme.colors.black4};
  // background: ${(props) => props.theme.colors.black4};
  border-radius: 20px;
  gap: 4px;
`;

export const TabButton = styled.div<MainPostTabStyleProps>`
  display: flex;
  // width: 100%;
  width: fit-content;
  height: 30px;
  padding: 0 16px;
  color: ${(props) =>
    props.$active ? props.theme.colors.white100 : props.theme.colors.black20};
  font-size: 1.3rem;
  font-weight: ${(props) => (props.$active ? "700" : "400")};
  font-family: "Pretendard";
  background-color: ${(props) =>
    props.$active ? props.theme.colors.primary100 : props.theme.colors.black5};
  border-radius: 50px;
  align-items: center;
  justify-content: center;
`;

export const TabContent = styled.div``;
